module.exports = __webpack_public_path__ + "img/icon-bulb.3889afc5.svg";